let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1cD3m")).then(() => parcelRequire('aj5bY'));